import React, { useEffect } from "react";
import Space from "./Space/Space";
import ConfirmationModal from "./Modals/ConfirmationModal/ConfirmationModal";
import MainContent from "./MainContent/MainContent";
import RootBar from "./RootBar/RootBar";
import VideoBarContainer from "./VideoBarContainer/VideoBarContainer";
import AddPeople from "./MainContent/Text/AddPeople/AddPeople";
import BranchBar from "./BranchBar/BranchBar";
import NewAppModal from "./Modals/NewAppModal/NewAppModal";
import { goToHome, goToNodeWrapper } from "slices/efficeTreeSlice";
import RoomLinkModal from "./MainContent/Text/RoomLinkModal/RoomLinkModal";

const Home = ({
  match: {
    params: { node_id },
  },
}) => {
  useEffect(() => {
    if (node_id === "home") goToHome();
    else goToNodeWrapper(node_id);
  }, [node_id]);

  useEffect(() => {
    document.getElementById("space").style.visibility = "visible";
    document.getElementById("videobar").style.visibility = "visible";
  }, []);

  return (
    <div
      className={`home-main`}
      style={
        process.env.NODE_ENV !== "production" && false
          ? { backgroundColor: "#664412" }
          : null
      } // help me remember when im developing locally
    >
      <RootBar />
      <BranchBar />
      <NewAppModal />
      <AddPeople />
      <RoomLinkModal />
      <ConfirmationModal />

      <div className="right-section">
        <MainContent />
        <Space />
        <VideoBarContainer />
      </div>
    </div>
  );
};

export default Home;
